import {
    GET_ORDERS_START,
    GET_ORDERS_SUCCESS,
    GET_ORDERS_FAIL,
    GET_ORDER_DETAILS_SUCCESS,
    GET_ORDER_DETAILS_FAIL,
    ORDER_STATUS_CHANGE_SUCCESS,
    ORDER_STATUS_CHANGE_FAIL,
    ORDER_STATUS_CHANGE_START,
    UPDATE_STATUS_STEP_START,
    UPDATE_STATUS_STEP_SUCCESS,
    UPDATE_STATUS_STEP_FAIL
} from '../actions/actionTypes';

const initialState = {
    loading: false,
    list: [],
    pages: 0,
    dataState: {
        pageSize: 20,
        page: 0,
        sorted: [{ id: "dateCreated", desc: true }],
        filtered: [],
    }
};

const getOrdersStart = (state) => {
    return ({
        ...state,
        loading: true,
        list: [],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        }
    })
}

const getOrdersSuccess = (state, { list, dataState, pages }) => {
    return ({
        ...state,
        pages,
        loading: false,
        list: [...list],
        dataState: {
            ...dataState,
            sorted: [...dataState.sorted],
            filtered: [...dataState.filtered]
        }
    })
}

const getOrdersFail = (state, { error }) => {
    return ({
        ...state,
        loading: false,
        list: [],
        error: error,
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        }
    })
}

const getOrderDetailsSuccess = (state, { order }) => {
    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        order: order
    })
}

const getOrderDetailsFail = (state, { error }) => {
    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        error: error
    })
}

const orderStatusChangeSuccess = (state, { newStatus }) => {
    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        order: {
            ...state.order,
            loadingStatusChange: false,
            status: newStatus
        }
    })
}

const orderStatusChangeStart = (state) => {
    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        order: {
            ...state.order,
            loadingStatusChange: true
        }
    })
}

const orderStatusChangeFail = (state, { error }) => {
    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        order: {
            ...state.order,
            loadingStatusChange: false,
            error: error
        }
    })
}

const updateStatusStepStart = (state) => {
    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        order: {
            ...state.order,
            loadingStatusStep: true
        }
    })
}

const updateStatusStepSuccess = (state, { stepData }) => {
    
    if (!state.order) {
        console.log('No order in state, returning unchanged state');
        return state;
    }

    const currentStatusSteps = state.order.statusSteps || [];
    
    const updatedStatusSteps = [...currentStatusSteps];
    const existingIndex = updatedStatusSteps.findIndex(step => step.status === stepData.status);
    
    if (stepData.action === 'add') {
        const statusStepData = {
            status: stepData.status,
            completed: stepData.completed,
            timestamp: stepData.timestamp,
            employeeName: stepData.employeeName,
            comment: stepData.comment || ''
        };

        if (existingIndex >= 0) {
            updatedStatusSteps[existingIndex] = statusStepData;
        } else {
            updatedStatusSteps.push(statusStepData);
        }
    } else if (stepData.action === 'remove' && existingIndex >= 0) {
        updatedStatusSteps.splice(existingIndex, 1);
    }


    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        order: {
            ...state.order,
            loadingStatusStep: false,
            statusSteps: updatedStatusSteps
        }
    })
}

const updateStatusStepFail = (state, { error }) => {
    return ({
        ...state,
        loading: false,
        list: [...state.list],
        dataState: {
            ...state.dataState,
            sorted: [...state.dataState.sorted],
            filtered: [...state.dataState.filtered]
        },
        order: {
            ...state.order,
            loadingStatusStep: false,
            error: error
        }
    })
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDERS_START:
            return getOrdersStart(state, action)
        case GET_ORDERS_SUCCESS:
            return getOrdersSuccess(state, action)
        case GET_ORDERS_FAIL:
            return getOrdersFail(state, action)
        case GET_ORDER_DETAILS_SUCCESS:
            return getOrderDetailsSuccess(state, action)
        case GET_ORDER_DETAILS_FAIL:
            return getOrderDetailsFail(state, action)
        case ORDER_STATUS_CHANGE_START:
            return orderStatusChangeStart(state, action)
        case ORDER_STATUS_CHANGE_SUCCESS:
            return orderStatusChangeSuccess(state, action)
        case ORDER_STATUS_CHANGE_FAIL:
            return orderStatusChangeFail(state, action)
        case UPDATE_STATUS_STEP_START:
            return updateStatusStepStart(state, action)
        case UPDATE_STATUS_STEP_SUCCESS:
            return updateStatusStepSuccess(state, action)
        case UPDATE_STATUS_STEP_FAIL:
            return updateStatusStepFail(state, action)
        default:
            return state;
    }
};